import "core-js/stable";
import "regenerator-runtime/runtime";
import 'jquery';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/button';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/themes/base/base.css';
import 'jquery-ui-timepicker-addon/dist/jquery-ui-timepicker-addon.css';
import 'select2/dist/css/select2.css'
import 'select2-bootstrap-theme/dist/select2-bootstrap.css'
import 'jquery-query-object/jquery.query-object';
import 'jqGrid/css/ui.jqgrid.css';
import 'bootstrap-fileinput/css/fileinput.css';
import toastr from 'toastr';
import 'toastr/toastr.scss';
import 'tooltipster/dist/js/tooltipster.bundle';
import 'tooltipster/dist/css/tooltipster.bundle.css';
import 'tooltipster/dist/css/plugins/tooltipster/sideTip/themes/tooltipster-sideTip-shadow.min.css';
import 'tooltipster-scrollabletip/tooltipster-scrollableTip'
import 'globalize';
import 'cldrjs';
import 'patternfly-bootstrap-treeview/src/css/bootstrap-treeview.css'
import axios from 'axios';

/**
 * jQuery.browser.mobile (http://detectmobilebrowser.com/)
 *
 * jQuery.browser.mobile will be true if the browser is a mobile device
 *
 **/
(function(a) {
    (jQuery.browser = jQuery.browser || {}).mobile =
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
        .test(a) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
        .test(a.substr(0, 4));
})(navigator.userAgent || navigator.vendor || window.opera);

(function() {
    // Set globals
    window.$ = $;
    window.jQuery = $;
    window.toastr = toastr;
    window.axios = axios;
    const Globalize = TKDialogs.Globalize = window.TKDialogs.Globalize;
    const inputForm = $('form[name=tkinputform]');
    const inputFields = inputForm
        .find('input,textarea,select') // Get all input fields
        .not('[type=submit], [type=button], [type=hidden]'); // Exclude buttons and hidden input fields
    const originalVal = $.fn.val;
    $.fn.val = function() {
        const args = Array.prototype.slice.call(arguments);

        // Best practice: return immediately if empty matched set
        if (!this.length) {
            return args.length ? this : undefined;
        }
        let currentValue, result = currentValue = originalVal.apply(this);
        if (args.length) {
            const $this = $(this);
            const newValue = args[0];
            result = originalVal.apply(this, args);
            if (newValue !== currentValue) {
                // raise the change event
                $this.change();
            }
        }
        return result;
    };
    Date.prototype.toDateInputValue = (function() {
        var local = new Date(this);
        local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
        return local.toJSON().slice(0, 10);
    });
    Date.prototype.toDatetimeInputValue = (function() {
        var
            date = this,
            ten = function(i) {
                return (i < 10 ? '0' : '') + i;
            },
            YYYY = date.getFullYear(),
            MM = ten(date.getMonth() + 1),
            DD = ten(date.getDate()),
            HH = ten(date.getHours()),
            II = ten(date.getMinutes()),
            SS = ten(date.getSeconds());
        return YYYY +
            '-' +
            MM +
            '-' +
            DD +
            'T' +
            HH +
            ':' +
            II +
            ':' +
            SS;
    });
    Date.prototype.fromDatetimeLocal = (function(BST) {
        // BST should not be present as UTC time
        return new Date(BST).toISOString().slice(0, 16) === BST
            ?
            // if it is, it needs to be removed
            function() {
                return new Date(
                    this.getTime() +
                    (this.getTimezoneOffset() * 60000)
                ).toISOString();
            }
            :
            // otherwise can just be equivalent of toISOString
            Date.prototype.toISOString;
    }('2006-06-06T06:06'));

    window.TKDialogs.runGraphQLQuery = function(graphQLParams, onQuerySuccess, onQueryFailure) {
        if (!$.isFunction(onQuerySuccess))
            throw '"onQuerySuccess" must be a function';
        var timeout = setTimeout(function() {
                $("#processing").dialog("open");
                window.status = "Please wait. Your request is being processed...";
            },
            1000);
        return axios.post('./api/graphql', graphQLParams)
            .then(resp => {
                onQuerySuccess(resp.data);
            })
            .catch(error => {
                if (onQueryFailure && $.isFunction(onQueryFailure))
                    onQueryFailure(error);
                else
                    console.error('GraphQL query execution failed:', error);
            })
            .then(() => {
                clearTimeout(timeout);
                $('#processing').dialog('close');
                window.status = '';
            });
    };

    window.TKDialogs.applyBusinessRules = async function(rules) {
        const { RulesEngine } = await import('./rules-engine');
        const engine = new RulesEngine(rules);
        engine.run();
    };

    function configureDependencies() {
        return new Promise((onSuccess, onError) => {
            setTimeout(async () => {
                    try {
                        if ($('#tree').length) // listflows
                        {
                            await import('patternfly-bootstrap-treeview/src/js/bootstrap-treeview');
                        }
                        if ($('#progressbar').length) 
                        {
                            await import('jquery-ui/ui/widgets/progressbar');
                        }
                        if ($('div[data-displaytype="tabgroup"]', inputForm).length) {
                            await import('jquery-ui/ui/widgets/tabs');
                        }
                        if ($('div[data-displaytype="accordiongroup"]', inputForm).length) {
                            await import('jquery-ui/ui/widgets/accordion');
                        }
                        if ($('input[data-number-displaytype="Slider"]', inputForm).length) {
                            await import('jquery-ui/ui/widgets/slider');
                        }
                        if ($('input[data-number-displaytype="Spinner"], input[data-number-displaytype="currency"]', inputForm).length) {
                            await import('jquery-ui/ui/widgets/spinner');
                        }
                        if ($('input[type=date], input[data-rule-date], input[type=datetime-local], input[data-rule-datetime]', inputForm).length) {
                            await import('jquery-ui/ui/widgets/datepicker');
                        }
                        if ($('input[type=datetime-local], input[data-rule-datetime]', inputForm).length) {
                            await import('jquery-ui-timepicker-addon');
                        }
                        if ($('div.grid-container', inputForm).length) {
                            await import('jqGrid/js/i18n/grid.locale-en');
                            await import('jqGrid/js/jquery.jqGrid');
                            await import('./grid.tbltogrid');
                        }
                        if ($(".list[data-displayType='dropdown']", inputForm).length) {
                            await import('select2');
                        }
                        if ($('input[type=file]', inputForm).length) {
                            await import('bootstrap-fileinput/js/fileinput');
                        }
                        onSuccess();
                    } catch (e) {
                        onError(e);
                    }
                },
                0);
        });
    }

    function configureLocalization() {
        return new Promise((onSuccess, onError) => {
            setTimeout(async () => {
                    try {
                        /* Retrieve the default language set for the browser. */
                        const dialogLanguage = inputForm.data('language');
                        const { availableLocales: availableLocales } = await import('cldr-data/availableLocales.json');
                        let locale = normaliseLang(dialogLanguage ||
                            navigator.language /* Mozilla */ ||
                            navigator.userLanguage /* IE */);
                        window.TKDialogs.availableLocales = availableLocales;
                        window.TKDialogs.locale = locale = findClosestCulture(locale);
                        if (!locale) throw new Error(`Requested locale ${locale} is not supported`);
                        const culture = locale.split('-')[0];
                        $('html').attr('lang', locale);

                        // Configure Globalize
                        const { default: caGregorian } = await import(`cldr-data/main/${locale}/ca-gregorian`);
                        const { default: currencies } = await import(`cldr-data/main/${locale}/currencies`);
                        const { default: dateFields } = await import(`cldr-data/main/${locale}/dateFields`);
                        const { default: numbers } = await import(`cldr-data/main/${locale}/numbers`);
                        const { default: timeZoneNames } = await import(`cldr-data/main/${locale}/timeZoneNames`);
                        const { default: units } = await import(`cldr-data/main/${locale}/units`);
                        const { default: currencyData } = await import('cldr-data/supplemental/currencyData');
                        const { default: likelySubtags } = await import('cldr-data/supplemental/likelySubtags');
                        const { default: metaZones } = await import('cldr-data/supplemental/metaZones');
                        const { default: plurals } = await import('cldr-data/supplemental/plurals');
                        const { default: timeData } = await import('cldr-data/supplemental/timeData');
                        const { default: weekData } = await import('cldr-data/supplemental/weekData');
                        const { default: ianaTzData } = await import('iana-tz-data');
                        const messages = await axios({
                            method: 'GET',
                            url: './Scripts/localization/resources.json'
                        }).then(resp => resp.data);
                        Globalize.load(
                            caGregorian,
                            currencies,
                            dateFields,
                            numbers,
                            timeZoneNames,
                            units,
                            currencyData,
                            likelySubtags,
                            metaZones,
                            plurals,
                            timeData,
                            weekData
                        );
                        Globalize.loadMessages(messages);
                        Globalize.loadTimeZone(ianaTzData);
                        Globalize.locale(window.TKDialogs.locale);

                        // Load localization data for grid if necessary
                        try {
                            if (locale !== 'en'
                                && inputForm.has('div.grid-container'))
                                await import(`jqGrid/js/i18n/grid.locale-${locale}`)
                                    .catch(_ => import(`jqGrid/js/i18n/grid.locale-${culture}`));
                        } catch (gridEx) {
                            console.warn(`Unable to load grid localization for locale '${locale}':`, gridEx);
                        }

                        // Load localization data for datepicker
                        try {
                            if (locale !== 'en' 
                                && $('input[type=date], input[data-rule-date], input[type=datetime-local], input[data-rule-datetime]', inputForm).length)
                                await import(`jquery-ui/ui/i18n/datepicker-${locale}`)
                                    .catch(_ => import(`jquery-ui/ui/i18n/datepicker-${culture}`))
                                    .catch(reason => Promise.resolve(
                                        console.warn(`Unable to load datepicker localization for locale '${locale}':`,
                                            reason)));
                            if (locale !== 'en' 
                                && $('input[type=datetime-local], input[data-rule-datetime]', inputForm).length)
                                await import(`jquery-ui-timepicker-addon/dist/i18n/jquery-ui-timepicker-${locale}`)
                                    .catch(_ => import(
                                        `jquery-ui-timepicker-addon/dist/i18n/jquery-ui-timepicker-${culture}`))
                                    .catch(_ => import(
                                        `jquery-ui-timepicker-addon/dist/i18n/jquery-ui-timepicker-addon-i18n`));
                        } catch (dpEx) {
                            console.warn(`Unable to load datepicker localization for locale '${locale}':`, dpEx);
                        }
                        // Set text direction
                        var textDirection =
                            Globalize.cldr.main(['layout/orientation/characterOrder']) === 'right-to-left'
                                ? 'rtl'
                                : null;
                        if (textDirection && textDirection.toLowerCase() !== 'ltr') {
                            setDirection(textDirection);
                        }
                        // Include recaptcha if required
                        const hasRecaptcha = inputForm.has('input[data-displayType=recaptcha]');
                        if (hasRecaptcha && hasRecaptcha.length) {
                            var recaptchaUrl =
                                'https://www.google.com/recaptcha/api.js?render=explicit&onload=prepareRecaptcha&hl=' +
                                    locale;
                            $('head').append(jQuery('<script id="recaptcha_js" type="text/javascript" async src="' +
                                recaptchaUrl +
                                '"  />'));
                        }
                        onSuccess();
                    } catch (e) {
                        onError(e);
                    }
                },
                0);
        });
    }

    function configureThemes() {
        return new Promise((onSuccess, onError) => {
            setTimeout(async () => {
                    try {
                        // Configure themes
                        const themes = await axios({
                            method: 'GET',
                            url: './Content/themes/themes.json'
                        }).then(resp => resp.data);
                        let themeLink = jQuery('head link#ui-theme');
                        if (themeLink.length === 0)
                            jQuery('head').append(themeLink =
                                jQuery('<link href="" type="text/css" rel="Stylesheet" id="ui-theme" />'));
                        const themeName = $.query.get('theme') ||
                            $.cookie('tkdialogs-theme') ||
                            themeLink.data('default-theme') ||
                            themes.defaultTheme;
                        const match = $.grep(themes.themes,
                            function(t) { return t.name && t.name.toLowerCase() === themeName.toLowerCase() });
                        const theme = match.length > 0 ? match[0] : null;
                        if (theme) {
                            themeLink.attr('href', theme.css);
                            var isSecure = document.location.protocol.indexOf('https') === 0 || false;
                            $.cookie('tkdialogs-theme', themeName, { secure: isSecure, sameSite: isSecure });
                            themeLink.on('load', () => onSuccess());
                        } else {
                            console.warn(`Theme '${themeName}' was not recognized and thus could not be loaded`);
                            onSuccess();
                        }
                    } catch (e) {
                        onError(e);
                    }
                },
                0);
        });
    }

    function runDialogTasks() {
        return new Promise((onSuccess, onError) => {
            setTimeout(
                async () => {
                    try {
                        const tasks = window.TKDialogs.dialogTasks;
                        if (tasks && tasks.length) {
                            await tasks.reduce(function(sequence, task) {
                                    // once last task is done
                                    return sequence.then(function() {
                                        // run next task
                                        return new Promise(function(resolve, reject) {
                                            setTimeout(function() {
                                                    try {
                                                        task();
                                                        resolve();
                                                    } catch (e) {
                                                        reject(e);
                                                    }
                                                },
                                                0);
                                        });
                                    });
                                },
                                Promise.resolve());
                        }
                        onSuccess();
                    } catch (e) {
                        onError(e);
                    }
                },
                0);
        });
    }

    async function initialize() {
        let timeout;
        try {

            window.status = "Loading...";
            inputForm.css({ display: 'block', visibility: 'hidden' });
            // Set up the processing dialog
            const processingDialog = $("#processing").dialog({
                autoOpen: false,
                modal: true,
                draggable: false,
                height: "auto",
                width: "auto",
                minHeight: null,
                resizable: false
                //title: "Processing..."
            });
            processingDialog.siblings("div.ui-dialog-titlebar").remove();
            processingDialog.parents(".ui-dialog").removeClass("ui-widget-content")
                .removeAttr("aria-labelledby");
            timeout = setTimeout(() => {
                    if (processingDialog.dialog('open').is('video'))
                        processingDialog[0].play();
                },
                100);

            // Run startup tasks
            const configurationTasks = await Promise.all([configureDependencies(), configureLocalization(), configureThemes()]);
            console.debug('Completed configuration tasks...', configurationTasks);
            const startupTasks = await runDialogTasks();
            console.debug('Completed startup tasks...', startupTasks);

            // Set the page title.
            var titleText = $.trim($('.brand').first().text());
            if (titleText)
                document.title = 'TKDialogs: ' + titleText;
            // Prevent back navigation - trick it into staying on the same page
            $(window).on('popstate',
                function (e) {
                    if (history && history.pushState)
                        history.pushState(null, null, window.location);
                });
            if (history && history.pushState) {
                history.pushState(null, null, window.location);
            }
        } catch (ex) {
            if (console && console.error)
                console.error('An error occurred while running initialization tasks: ', ex);
            alert('Errors occurred during start-up. The page may not be displayed correctly.');
            if (document.tkinputform != null) {
                document.tkinputform.style.visibility = 'visible';
            }
        } finally {
            if (timeout) clearTimeout(timeout);
            $('#processing').dialog('close');
            inputForm
                .css({ display: 'block', visibility: 'visible'})
                .trigger('dialogLoaded');
            inputFields.not('[readonly]').first().focus();
            window.status = '';
        }

    }

    jQuery.cookie = function(name, value, options) {
        if (typeof value != 'undefined') { // name and value given, set cookie

            options = options || {};

            if (value === null) {
                value = '';
                options.expires = -1;
            }

            var expires = '';
            if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
                var date;
                if (typeof options.expires == 'number')
                    date = (new Date()).setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
                else
                    date = options.expires;

                expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
            }
            // CAUTION: Needed to parenthesize options.path and options.domain
            // in the following expressions, otherwise they evaluate to undefined
            // in the packed version for some reason...
            var path = options.path ? '; path=' + (options.path) : '';
            var domain = options.domain ? '; domain=' + (options.domain) : '';
            var secure = options.secure ? '; secure' : '';
            var sameSite = options.sameSite ? '; SameSite=strict' : '';
            document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure, sameSite].join('');
        } else { // only name given, get cookie
            var cookieValue = null;
            if (document.cookie && document.cookie != '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = jQuery.trim(cookies[i]);
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) == (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;

        }

    };

    function normaliseLang(lang) {
        /* Ensure language code is in the format aa-AA. */
        lang = lang.replace(/_/, '-').toLowerCase();
        if (lang.length > 3) {
            lang = lang.substring(0, 3) + lang.substring(3).toUpperCase();
        }
        return lang;
    }

    function findClosestCulture(name) {
        var match;
        if (!name) {
            return findClosestCulture(this.cultureSelector) || this.cultures['default'];
        }
        if (typeof name === 'string') {
            name = name.split(',');
        }
        if (Array.isArray(name)) {
            var lang,
                cultures = window.TKDialogs.availableLocales,
                list = name,
                i,
                l = list.length,
                prioritized = [];
            for (i = 0; i < l; i++) {
                name = $.trim(list[i]);
                var pri, parts = name.split(';');
                lang = $.trim(parts[0]);
                if (parts.length === 1) {
                    pri = 1;
                } else {
                    name = $.trim(parts[1]);
                    if (name.indexOf('q=') === 0) {
                        name = name.substr(2);
                        pri = parseFloat(name);
                        pri = isNaN(pri) ? 0 : pri;
                    } else {
                        pri = 1;
                    }
                }
                prioritized.push({ lang: lang, pri: pri });
            }
            prioritized.sort(function(a, b) {
                if (a.pri < b.pri) {
                    return 1;
                } else if (a.pri > b.pri) {
                    return -1;
                }
                return 0;
            });
            // exact match
            for (i = 0; i < l; i++) {
                lang = prioritized[i].lang;
                match = $.inArray(lang, cultures) > -1 ? lang : null;
                if (match) {
                    return match;
                }
            }

            // neutral language match
            for (i = 0; i < l; i++) {
                lang = prioritized[i].lang;
                do {
                    var index = lang.lastIndexOf('-');
                    if (index === -1) {
                        break;
                    }
                    // strip off the last part. e.g. en-US => en
                    lang = lang.substr(0, index);
                    match = $.inArray(lang, cultures) > -1 ? lang : null;
                    if (match) {
                        return match;
                    }
                } while (1);
            }

            // last resort: match first culture using that language
            //for (i = 0; i < l; i++) {
            //    lang = prioritized[i].lang;
            //    for (var cultureKey in cultures) {
            //        var culture = cultures[cultureKey];
            //        if (culture.language === lang) {
            //            return culture;
            //        }
            //    }
            //}
        } else if (typeof name === 'object') {
            return name;
        }
        return match || null;
    }

    function setDirection(direction) {
        window.TKDialogs.rtl = toastr.options.rtl = (direction === 'rtl');
        document.getElementsByTagName('html')[0].style.direction = direction;
        $('html').addClass('right-to-left');
        var styleSheets = document.styleSheets;
        var modifyRule = function(rule) {
            if (rule.style.getPropertyValue(window.TKDialogs.rtl ? 'left' : 'right') &&
                rule.selectorText.match(/\.col-(xs|sm|md|lg)-push-\d\d*/)) {
                rule.style.setProperty((window.TKDialogs.rtl ? 'right' : 'left'),
                    rule.style.getPropertyValue((window.TKDialogs.rtl ? 'left' : 'right')));
                rule.style.removeProperty((window.TKDialogs.rtl ? 'left' : 'right'));
            }
            if (rule.style.getPropertyValue(window.TKDialogs.rtl ? 'right' : 'left') &&
                rule.selectorText.match(/\.col-(xs|sm|md|lg)-pull-\d\d*/)) {
                rule.style.setProperty((window.TKDialogs.rtl ? 'left' : 'right'),
                    rule.style.getPropertyValue((window.TKDialogs.rtl ? 'right' : 'left')));
                rule.style.removeProperty((window.TKDialogs.rtl ? 'right' : 'left'));
            }
            if (rule.style.getPropertyValue(window.TKDialogs.rtl ? 'margin-left' : 'margin-right') &&
                rule.selectorText.match(/\.col-(xs|sm|md|lg)-offset-\d\d*/)) {
                rule.style.setProperty((window.TKDialogs.rtl ? 'margin-right' : 'margin-left'),
                    rule.style.getPropertyValue((window.TKDialogs.rtl ? 'margin-left' : 'margin-right')));
                rule.style.removeProperty((window.TKDialogs.rtl ? 'margin-left' : 'margin-right'));
            }
            if (rule.style.getPropertyValue('float') && rule.selectorText.match(/\.col-(xs|sm|md|lg)-\d\d*/)) {
                rule.style.setProperty('float', (window.TKDialogs.rtl ? 'right' : 'left'));
            }
        };
        try {
            for (var i = 0; i < styleSheets.length; i++) {
                var rules = styleSheets[i].cssRules || styleSheets[i].rules;
                if (rules) {
                    for (var j = 0; j < rules.length; j++) {
                        if (rules[j].type === 4) {
                            var mediaRules = rules[j].cssRules || rules[j].rules;
                            for (var y = 0; y < mediaRules.length; y++) {
                                modifyRule(mediaRules[y]);
                            }
                        }
                        if (rules[j].type === 1) {
                            modifyRule(rules[j]);
                        }
                    }
                }
            }
        } catch (e) {
            // Firefox might throw a SecurityError exception but it will work
            if (e.name !== 'SecurityError') {
                throw e;
            }
        }
    };

    initialize();
})();